import { Button, Heading, Span } from "@icg360/design-system";

import { formatValueFromBE } from "../../../utils/formatting";
import styles from "./Banner.module.css";

interface BannerProps {
  customerName: string;
  premium: string;
  producerName: string;
  producerAgency: string;
  producerEmail: string;
  producerPhone: string;
}

export const Banner = ({
  customerName,
  premium,
  producerName,
  producerAgency,
  producerEmail,
  producerPhone
}: BannerProps) => {
  const showAgency =
    producerName.toLowerCase() !== producerAgency.toLowerCase();
  return (
    <div className={styles.bannerContainer}>
      <div className={styles.summaryCard}>
        <Heading className={styles.customerHeadingDS} size="lg">
          <span className={styles.customerName}>
            {customerName.toLowerCase().trim()}
          </span>
          , your homeowner&apos;s quote is here!
        </Heading>
        <Span className={styles.customerTextDS}>
          <Span bold>
            {customerName.toLowerCase().trim()}, your quote is here!
          </Span>
        </Span>
        <Heading className={styles.styledHeadingDS} size="xl">
          {formatValueFromBE(premium)}
        </Heading>{" "}
        <Heading className={styles.styledHeadingDS} size="md">
          /yr
        </Heading>
        <Heading className={styles.providedTextDS} size="xs">
          Provided By
        </Heading>
        <Heading className={styles.producerNameHeadingDS} size="sm">
          {producerName}
        </Heading>
        <Span className={styles.producerNameTextDS} bold>
          {producerName}
        </Span>
        {showAgency ? <p>{producerAgency}</p> : null}
        <div className={styles.questionContainer}>
          <p className={styles.questionsText}>
            Have questions or ready to purchase? Contact me and we’ll work
            together to get the coverage you need.
          </p>
        </div>
        <div className={styles.callToActionButtons}>
          <div>
            <Button
              appearance="secondary"
              leadingIcon="Envelope"
              onPress={() => {
                window.location.href = `mailto:${producerEmail}`;
              }}
            >
              Email me
            </Button>
          </div>
          <Span className={styles.phoneTextDS}>{producerPhone}</Span>
          <div className={styles.phoneButton}>
            <Button
              leadingIcon="Phone"
              onPress={() => {
                window.location.href = `tel:${producerPhone}`;
              }}
            >
              Call me
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
